import React, { useState } from 'react';
import { validationApi } from '../api';

const sel = 'fm-select fm-focus mt-1 w-full border border-[#E7E2D3] rounded-md px-3 py-2 text-[13.5px] bg-white disabled:opacity-50';

export default function CoolingFields({ draft, setDraft, sku }) {
  const isTester = (draft.itemType || 'T') === 'T';
  return (
    <div className="col-span-2 grid grid-cols-3 gap-3 p-3 rounded-md bg-[#FBF9F3] border border-[#EFEADB]" data-testid="item-cooling-fields">
      <div>
        <label className="text-[12.5px] font-medium">Item Type</label>
        <select data-testid="item-modal-item-type" value={draft.itemType || 'T'} onChange={e => setDraft({ ...draft, itemType: e.target.value })} className={sel}>
          <option value="T">T · Tester</option><option value="NT">NT · Non-tester</option>
        </select>
      </div>
      <div>
        <label className="text-[12.5px] font-medium">Cooling period (days)</label>
        <input data-testid="item-modal-cooling-days" type="number" min="0" max="3650" disabled={!isTester}
          value={draft.coolingDays ?? ''} onChange={e => setDraft({ ...draft, coolingDays: e.target.value })}
          className="fm-focus mt-1 w-full border border-[#E7E2D3] rounded-md px-3 py-2 text-[13.5px] bg-white disabled:opacity-50" />
      </div>
      <div>
        <label className="text-[12.5px] font-medium">Cooling period</label>
        <select data-testid="item-modal-cooling-active" disabled={!isTester} value={draft.coolingActive === false ? 'off' : 'on'}
          onChange={e => setDraft({ ...draft, coolingActive: e.target.value === 'on' })} className={sel}>
          <option value="on">Active</option><option value="off">Inactive</option>
        </select>
      </div>
      <p className="col-span-3 text-[11.5px] text-[#7a6f5c]">
        Counted from the last confirmed delivery of this SKU to the same branch. 0 days or Inactive skips the cooling check; branch and HO stock checks still apply to Testers.
      </p>
      {sku && <CoolingHistory sku={sku} />}
    </div>
  );
}

const fmtAt = (v) => new Date(/Z|[+-]\d\d:\d\d$/.test(v) ? v : `${v}Z`).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const LABELS = { itemType: 'Item Type', coolingDays: 'Cooling days', coolingActive: 'Cooling active' };
const show = (v) => (v === true ? 'Active' : v === false ? 'Inactive' : v ?? '—');

function CoolingHistory({ sku }) {
  const [rows, setRows] = useState(null);
  const load = () => validationApi.coolingHistory(sku).then(setRows).catch(() => setRows([]));
  if (rows === null) {
    return <button type="button" onClick={load} data-testid="item-cooling-history-btn" className="col-span-3 text-left text-[12px] underline text-[#7a6f5c]">Show cooling change history</button>;
  }
  return (
    <div className="col-span-3 text-[12px]" data-testid="item-cooling-history">
      {rows.length === 0 ? <div className="text-[#7a6f5c]">No changes recorded yet.</div> : (
        <ul className="space-y-1 max-h-[140px] overflow-auto">
          {rows.map((r, i) => (
            <li key={i}><span className="text-[#7a6f5c]">{fmtAt(r.at)} · {r.by} · {r.source}:</span>{' '}
              {Object.entries(r.changes).map(([k, c]) => `${LABELS[k] || k} ${show(c.from)} → ${show(c.to)}`).join(', ')}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
